import React, { useEffect, useState } from 'react';
import { enableAnalytics, disableAnalytics, hasAnalyticsConsent, setAnalyticsConsent } from '../utils/analytics';
import { l } from '../lang/index.jsx';
import { supabase } from '../utils/supabase.js';

export default function SitePreferences({ lang }) {
    const [visible, setVisible] = useState(false);
    const [, setConsent] = useState(null);
    const [contentMap, setContentMap] = useState(null);

    useEffect(() => {
        supabase.from('cookies_content').select('key, fr, en')
            .then(({ data }) => {
                if (data) {
                    const map = {};
                    data.forEach(r => { map[r.key] = { fr: r.fr, en: r.en }; });
                    setContentMap(map);
                }
            });
    }, []);

    const t = (key) => contentMap?.[key]?.[lang] || l(key, lang);

    useEffect(() => {
        const current = hasAnalyticsConsent();
        setConsent(current);
        setVisible(current !== true && current !== false);

        window.__showSitePreferences = () => setVisible(true);
        window.__getAnalyticsConsent = () => hasAnalyticsConsent();

        const onStorage = (e) => {
            if (e && e.key === 'analytics_consent') {
                const val = e.newValue;
                const bool = val === 'true' ? true : (val === 'false' ? false : null);
                setConsent(bool);
                setVisible(bool === null);
            }
        };
        window.addEventListener('storage', onStorage);
        return () => {
            window.removeEventListener('storage', onStorage);
            delete window.__showSitePreferences;
            delete window.__getAnalyticsConsent;
        };
    }, []);

    const onAccept = () => {
        try {
            enableAnalytics();
            setConsent(true);
            setVisible(false);
        } catch (e) {
            setAnalyticsConsent(true);
            setConsent(true);
            setVisible(false);
        }
    };

    const onDecline = () => {
        disableAnalytics();
        setConsent(false);
        setVisible(false);
    };

    if (typeof document === 'undefined') return null;
    if (!visible) return null;

    const content = t('cookiesContent');

    return (
        <div className="cookies-banner" role="dialog" aria-live="polite">
            <div className="cookies-content">
                <span className="cookies-title">{t('cookiesTitle')}</span>
                <div className="cookies-content">
                    {content.split('\n').map((line, i, arr) => (
                        <span key={i}>{line}{i < arr.length - 1 ? <br/> : null}</span>
                    ))}
                </div>
            </div>
            <div className="cookies-buttons">
                <button className='button back-button' aria-label="Decline cookies" onClick={onDecline}>
                    <span>{t('cookiesDecline')}</span>
                </button>
                <button className='button' aria-label="Accept cookies" onClick={onAccept}>
                    <span>{t('cookiesAccept')}</span>
                </button>
            </div>
        </div>
    );
}
